<template>
  <div class="not-found-page">
    <div class="not-found-content">
      <div class="not-found-code">404</div>
      <div class="not-found-subtitle">Page not found</div>
      <p class="not-found-description">
        The page you are looking for doesn't exist or has been moved.
      </p>
      <router-link to="/" class="not-found-btn">
        Go back to dashboard
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundView"
};
</script>

<style lang="scss" scoped>
.not-found-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f1f5f9;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.not-found-content {
  text-align: center;
  padding: 48px 32px;
}

.not-found-code {
  font-size: 120px;
  font-weight: 800;
  color: #3b82f6;
  line-height: 1;
  letter-spacing: -4px;
  margin-bottom: 16px;
}

.not-found-subtitle {
  font-size: 28px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 12px;
}

.not-found-description {
  font-size: 15px;
  color: #64748b;
  margin-bottom: 36px;
}

.not-found-btn {
  display: inline-block;
  background: #3b82f6;
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
  padding: 12px 28px;
  border-radius: 8px;
  text-decoration: none;
  transition: background 0.2s ease;

  &:hover {
    background: #2563eb;
    color: #ffffff;
    text-decoration: none;
  }
}
</style>
